// extracted by mini-css-extract-plugin
export default {"settings":"Ikvj8","hidden":"DhNQA"};